import {UsersFiltersDTO} from "@/app/exercise/modules/users/core/DTO/UsersFiltersDTO";
import {FILTERS_ARGS} from "@/app/exercise/modules/users/core/models/UsersConst";
import {PaymentsService} from "@/app/exercise/modules/payments/core/payments-service";

export class UsersFiltersModel {

  constructor(filters) {
    this.filters = new UsersFiltersDTO(filters);
    this.options = {
      plans: {
        loading: false,
        list: []
      },
      statuses: {
        list: [
          {
            title: 'All',
            value: null
          },
          {
            title: 'Active',
            value: true
          },
          {
            title: 'Inactive',
            value: false
          }
        ]
      }
    };

    this.paymentsService = new PaymentsService();
  }

  async loadFilterOptions() {
    try {
      const {results} = await this.paymentsService.loadPlans();
      this.options.plans.list = results;
    } catch (e) {
      this.options.plans.list = [];
    }
  }

  getApiData() {
    return {
      [FILTERS_ARGS.SEARCH]: this.filters.search && this.filters.search.length ? this.filters.search : undefined,
      [FILTERS_ARGS.ACTIVE_PLAN]: this.filters.active_plan,
      [FILTERS_ARGS.IS_ACTIVE]: this.filters.is_active,
    };
  }
}
